module.exports = __webpack_public_path__ + "static/img/shezhi_touzhu.90ec5aea.png";